import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import Masked from 'react-text-mask';
import { Input } from './styles';
import useAutofocus from '../hooks/useAutofocus';
const MaskedInput = ({
  mask,
  autofocus,
  ...props
}, ref) => {
  const combineRefs = useAutofocus({
    autofocus
  });
  const pattern = mask?.pattern ?? mask;
  const pipe = mask?.pipe;
  const guide = false;
  return (
    /*#__PURE__*/
    // @NOTE guide is disabled because given it updates the input value on each
    // change it is extremelly annoying for people using a screen reader.
    React.createElement(Masked, _extends({}, props, {
      mask: pattern,
      pipe,
      guide,
      render: (maskedInputRef, inputProps) => /*#__PURE__*/React.createElement(Input, _extends({
        ref: combineRefs([maskedInputRef, ref])
      }, inputProps))
    }))
  );
};
export default /*#__PURE__*/forwardRef(MaskedInput);
//# sourceMappingURL=masked.js.map